import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cardOptions: 'Card options',
    deactivateAt: {
      date: 'The {date}',
      options: {
        custom: 'On the ',
        inDays: 'In {days} days',
        inMonth: 'In {months} month',
        tomorrow: 'Tomorrow',
      },
      placeholder: 'Pick a date',
      title: 'Deactivation date',
    },
    deactivationDate: 'Add an automatic deactivation date',
    isOptionNfcEnabled: {
      label: 'Contactless payment',
    },
    isOptionOnlineEnabled: {
      label: 'Online payment',
    },
    limitPaymentAll: {
      callout:
        'The card will be automatically deactivated once the total amount is reached.',
      errors: {
        max: 'The max total amount allocated is {max}',
        min: 'The min total amount allocated is {min}',
      },
      label: 'Amount allocated',
    },
    limitPaymentWeek: {
      error: 'The payment limit within a rolling 7-day window is {max}',
      hint: 'The maximum amount is {max}',
      label: 'Payments (over 7 rolling days)',
    },
    required: 'This field is required',
    settingLimits: 'Setting limits',
  },
  fr: {
    cardOptions: 'Options de carte bancaire',
    deactivateAt: {
      date: 'Le {date}',
      options: {
        custom: 'Le',
        inDays: 'Dans {days} jours',
        inMonth: 'Dans {months} mois',
        tomorrow: 'Demain',
      },
      placeholder: 'Sélectionnez une date',
      title: 'Date de désactivation',
    },
    deactivationDate: 'Ajouter une date de désactivation automatique',
    isOptionNfcEnabled: {
      label: 'Paiement sans contact',
    },
    isOptionOnlineEnabled: {
      label: 'Paiement en ligne',
    },
    limitPaymentAll: {
      callout:
        'La carte sera automatiquement désactivée une fois le montant total atteint. ',
      errors: {
        max: 'Le montant maximum pour le total alloué est de {max}',
        min: 'Le montant minimum pour le total alloué est de {min}',
      },
      label: 'Budget alloué',
    },
    limitPaymentWeek: {
      error:
        'Le plafond de paiement maximum est de {max} dans une fenêtre de 7 jours glissants.',
      hint: 'Le montant maximum est de {max}',
      label: 'Paiements (7 jours glissants)',
    },
    required: 'Ce champ est requis',
    settingLimits: 'Réglages des plafonds',
  },
} as const);

export default locales;
